import { render } from "./AccountOrderDetailsShipment.vue?vue&type=template&id=a30d7524"
import script from "./AccountOrderDetailsShipment.vue?vue&type=script&lang=js"
export * from "./AccountOrderDetailsShipment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__